import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCalendarStar } from '@fortawesome/pro-regular-svg-icons';
import { TranslateModule } from '@ngx-translate/core';
import { DateTimeFormat } from '@wilson/utils';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'wilson-drawer-stay-card',
  templateUrl: './drawer-stay-card.component.html',
  styleUrls: ['./drawer-stay-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule, NzTooltipModule, FontAwesomeModule],
})
export class DrawerStayCardComponent {
  @Input() stayId!: string;
  @Input() userId!: string;
  @Input() userName!: string;
  @Input() date!: string;
  @Input() locationName!: string;
  @Input() cancellationDate!: string | null;

  @Output() openStayDrawer = new EventEmitter();
  @Output() closeDrawer = new EventEmitter();
  @Output() navigateToTimeline = new EventEmitter();

  DateTimeFormat = DateTimeFormat;
  faCalendarStar = faCalendarStar;
}
